module.exports = __webpack_public_path__ + "img/mishal-saeed.9ac48148.jpg";